const HiddenField = ({ name, value, onChange }) => {
  return <></>;
};

export default HiddenField;
